<div  style="
display: flex;
justify-content: center;
align-items: center;
">
  <a class="btn btn-primary btn-primary--small" href="javascript:void(0)"
  (click)="callPardotAPI()">
  <i class="far fa-check-circle"></i>
  Test</a>
</div>